import script from "./invested-founder-card.vue?vue&type=script&setup=true&lang=js"
export * from "./invested-founder-card.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__